import React from 'react'
import { Modal as RNModal, GestureResponderEvent, TouchableOpacity, Linking } from 'react-native'
import { useTranslation } from 'react-i18next'

import {
  CenteredView,
  ModalView,
  ButtonContainer,
  IconContainer,
  ButtonsContainer,
  Button,
  BodyContainer,
  Body,
  TitleModal
} from './styled'

import CheckIcon from '../../icons/check-icon'
import BodyEmail from '../../typography/body-email'

export interface ModalProps {
  visible?: boolean;
  onPress?: (event: GestureResponderEvent) => void;
  onCloseModal?: () => void;
}

const NoXpPremiumModal = ({ onPress, visible, onCloseModal }: ModalProps) => {
  const { t } = useTranslation()

  return (
    <RNModal
      animationType="fade"
      visible={visible}
      presentationStyle="overFullScreen"
      statusBarTranslucent={false}
      transparent
      onRequestClose={onCloseModal}
    >
      <CenteredView testID="no-xp-premium-modal">
        <ModalView>
          <IconContainer>
            <CheckIcon />
          </IconContainer>
          <TitleModal>{t('Components.modal.noXpPremium.title')}</TitleModal>
          <BodyContainer>
            <Body>
              {t('Components.modal.noXpPremium.firstPartBody')}
              <TouchableOpacity>
                <BodyEmail style={{ color: '#33A3D9' }} onPress={() => Linking.openURL('mailto:soporte@hedgit.ai')}>
                  soporte@hedgit.ai
                </BodyEmail>
              </TouchableOpacity>
              {t('Components.modal.noXpPremium.secondPartBody')}
            </Body>
          </BodyContainer>
          <ButtonsContainer>
            <ButtonContainer>
              <Button testID="no-xp-premium-modal-button" onPress={onPress} variant="primary">
                {t('Components.button.ok')}
              </Button>
            </ButtonContainer>
          </ButtonsContainer>
        </ModalView>
      </CenteredView>
    </RNModal>
  )
}

export default NoXpPremiumModal
